var _defs, _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnifyDarkFevicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 267 283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient);\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #05204b;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 114,
    y1: 677.8,
    x2: 157,
    y2: 796.5,
    gradientTransform: "translate(0 -579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#199efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e35fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 125.6,
    y1: 755.6,
    x2: 155.7,
    y2: 831.9,
    gradientTransform: "translate(0 -579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#199efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e35fd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 267,
    height: 283,
    rx: 39.9,
    ry: 39.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134,105.8c33.9,16.2,69.1,30.5,103,47-.4.3-7.8,4.9-8.2,5.3v51.7c-3.7.4-5.2.6-9,0v-47.2c-5.2,1.9-43.4,18.2-50.7,21.4-11.6,5.6-23.9,10-35,16.2-32.8-16.4-70.3-31.3-104-47.7,34.5-15.8,69.2-31.3,104-46.6h-.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,105.8c33.9,16.2,69.1,30.5,103,47-.4.3-7.8,4.9-8.2,5.3v51.7c-3.7.4-5.2.6-9,0v-47.2c-5.2,1.9-43.4,18.2-50.7,21.4-11.6,5.6-23.9,10-35,16.2-32.8-16.4-70.3-31.3-104-47.7,34.5-15.8,69.2-31.3,104-46.6h-.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.4,182.2c20.1,9.7,42.2,17.8,62.1,28.1,17.5-9.2,43.5-19.8,62.2-28,.3,9.9,1.1,22.2-.1,32-.3,2.7-1.8,3.1-3.9,4.4-20,9.7-43.4,16.1-58.1,31.9-12.6-13.9-43.9-25.7-62.1-34-.4-11.1,0-23.2,0-34.4h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.4,182.2c20.1,9.7,42.2,17.8,62.1,28.1,17.5-9.2,43.5-19.8,62.2-28,.3,9.9,1.1,22.2-.1,32-.3,2.7-1.8,3.1-3.9,4.4-20,9.7-43.4,16.1-58.1,31.9-12.6-13.9-43.9-25.7-62.1-34-.4-11.1,0-23.2,0-34.4h-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.5,32.9c17.9-4.7,36.4,5.5,41.1,22.8,4.8,17.3-6,35-23.9,39.5-17.8,4.4-35.9-5.8-40.7-22.9-4.7-17.1,5.8-34.7,23.5-39.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnifyDarkFevicon);
export default __webpack_public_path__ + "static/media/learnifyDarkFevicon.4ca7902a42369a27a07ce2a323d034b4.svg";
export { ForwardRef as ReactComponent };